import React from "react";

import IniciativasPage from "./IniciativasPage";

const ProgramasPage = () => <IniciativasPage programMode />;

export default ProgramasPage;
